import { COLORS } from '@btime/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useOpenStocksModal,
  useOpenDetailsStockModal,
  useOpenTransferStockItemHistoryModal,
  useOpenGenerateActivatedQRCodesModal
} from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveStocks } from '../../_requests/removeStocks'
import { useSessionPermission } from '@btime/react-session'
import { appendIf } from '@btime/helpers'

export const useRowsActions = (item, ids) => {
  const { t } = useTranslation('listStocks')
  const openStocksModal = useOpenStocksModal()
  const openTransferStockItemHistoryModal = useOpenTransferStockItemHistoryModal()
  const openGenerateActivatedQRCodesModal = useOpenGenerateActivatedQRCodesModal()
  const openDetailsModal = useOpenDetailsStockModal()
  const [deleteItems] = useRemoveStocks()

  let canEdit = useSessionPermission('editStocks')
  let canDelete = useSessionPermission('deleteStocks')
  const singleOptions = useMemo(
    () => [
      {
        value: t('actions.viewDetails'),
        icon: 'BsSearch',
        onClick: () => openDetailsModal(item)
      },
      ...appendIf(canEdit, {
        value: t('actions.edit'),
        icon: 'BsPencil',
        onClick: () => openStocksModal(item?.id || ids[0])
      }),
      ...appendIf(canEdit, {
        value: t('actions.transfers'),
        icon: 'RiArrowLeftRightFill',
        onClick: () => openTransferStockItemHistoryModal(item?.id || ids[0])
      }),
      {
        value: t('actions.qrCode'),
        icon: 'IoQrCodeOutline',
        onClick: () => openGenerateActivatedQRCodesModal({ ids: [item?.id || ids?.[0]], type: 'stocks' })
      },
      ...appendIf(canDelete, {
        value: t('actions.remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems(item?.id || ids[0])
      })
    ],
    [item, deleteItems, openStocksModal, openTransferStockItemHistoryModal, canDelete, canEdit, t]
  )

  const multipleOptions = useMemo(
    () => [
      {
        value: t('actions.qrCode'),
        icon: 'IoQrCodeOutline',
        onClick: () => openGenerateActivatedQRCodesModal({ ids, type: 'stocks' })
      }
    ],
    [ids, deleteItems, canDelete, t]
  )

  return [!ids || ids.length === 1 ? singleOptions : multipleOptions, false]
}
